import { ICategoryCommission, ICategoryCommissionHistory, ICommissionHistoryFilters } from '@/models/commission.model';
import { IPagination } from '@/models/pagination.model';
import { TCommissionHistoryQuery } from '../helpers';

export const COMMISSION_SLICE_NAME = 'commission';

export interface CommissionState {
  categories: ICategoryCommission[];
  historyList: ICategoryCommissionHistory[];
  historyPagination: IPagination | null;
  historyQuery: TCommissionHistoryQuery;
  historyFilters: ICommissionHistoryFilters | null;
  isLoading: boolean;
  isSaving: boolean;
  isHistoryListLoading: boolean;
  isHistoryFiltersLoading: boolean;
  error: unknown;
}

export const initialHistoryQuery: TCommissionHistoryQuery = {
  page: 1,
};

export const initialState: CommissionState = {
  categories: [],
  historyList: [],
  historyPagination: null,
  historyQuery: initialHistoryQuery,
  historyFilters: null,
  isLoading: false,
  isSaving: false,
  isHistoryListLoading: false,
  isHistoryFiltersLoading: false,
  error: null,
};
